import React from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import { WarningIconBig } from '@rsmus/myrsm-icons'
import { Trans, useTranslation } from 'react-i18next'
import ResponsiveModal from '../../../rsmCoreComponents/components/ResponsiveModal'
import { Styles } from '../../../types'

interface TermsAndConditionsDialogProps {
  open: boolean
  onAccept: () => void
  onClose: () => void
  isMasterClientIdsame: boolean
}

const styles: Styles = {
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '5%',
    backgroundColor: 'white',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    maxHeight: '100%',
    height: '100%',
  },
  title: {
    fontFamily: 'Prelo-Book, sans-serif',
    fontSize: '2.25rem',
    lineHeight: '2.5rem',
    marginTop: '2rem',
    marginBottom: '1rem',
  },
  acceptWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexFlow: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '1.5rem',
    paddingTop: '2rem',
    paddingBottom: '2rem',
  },
  notetext: {
    fontFamily: 'Prelo-Book, sans-serif',
    marginTop: '1rem',
  },
}

const TermsAndConditionsDialog = ({
  open,
  onAccept,
  onClose,
  isMasterClientIdsame,
}: TermsAndConditionsDialogProps) => {
  const { t } = useTranslation()

  return (
    <Box className="Rsm-ProfileModal" data-testid="WarningpopupModal">
      <ResponsiveModal
        open={open}
        onClose={onClose}
        aria-label={
          isMasterClientIdsame
            ? t('Invoicing.UnrelatedInvoicesDialog.TitleMutliclient')
            : t('Invoicing.UnrelatedInvoicesDialog.Title')
        }
        desktopMaxHeight="29rem"
        desktopMaxWidth="40rem"
        removeHeaderSpacing>
        <Box sx={styles.dialogContent} data-testid="WarningPopupContent">
          <WarningIconBig />
          <Typography variant="h1" sx={styles.title} data-testid="WarningTitle">
            {isMasterClientIdsame
              ? t('Invoicing.UnrelatedInvoicesDialog.TitleMutliclient')
              : t('Invoicing.UnrelatedInvoicesDialog.Title')}
          </Typography>
          <Typography variant="body1" data-testid="WarningSubTitle">
            {isMasterClientIdsame
              ? ''
              : t('Invoicing.UnrelatedInvoicesDialog.Subtitle')}
          </Typography>
          <Typography sx={styles.notetext} data-testid="WarningNoteMessage">
            <Trans
              i18nKey={
                isMasterClientIdsame
                  ? 'Invoicing.UnrelatedInvoicesDialog.NoteMessageMutli'
                  : 'Invoicing.UnrelatedInvoicesDialog.NoteMessage'
              }
              components={{ b: <b /> }}
            />
          </Typography>
          <Stack sx={styles.acceptWrapper}>
            <Button
              variant="outlined"
              onClick={onClose}
              data-testid="WarningCancelButton">
              {t('Invoicing.UnrelatedInvoicesDialog.Cancel')}
            </Button>
            <Button
              variant="contained"
              onClick={onAccept}
              data-testid="WarningProceedButton">
              {t('Invoicing.UnrelatedInvoicesDialog.Proceed')}
            </Button>
          </Stack>
        </Box>
      </ResponsiveModal>
    </Box>
  )
}

export default TermsAndConditionsDialog
